<template>
    <section class="image_loader_placeholder">
        <div class="flower-spinner">
  <div class="dots-container">
    <div class="bigger-dot">
      <div class="smaller-dot"></div>
    </div>
  </div>
</div>
    </section>
  </template>
  <script>

  export default {
    data() {
      return { };
    }, components: {
        
  }

  };
  </script>
  <style scoped>


    .flower-spinner {
      height: 70px;
      width: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: auto;
    }

    .flower-spinner .dots-container {
      height: calc(70px / 7);
      width: calc(70px / 7);
    }

    .flower-spinner .smaller-dot {
      background: #1976d2;
      height: 100%;
      width: 100%;
      border-radius: 50%;
      animation: flower-spinner-smaller-dot-animation 2.5s 0s infinite both;

    }

    .flower-spinner .bigger-dot {
      background: #1976d2;
      height: 100%;
      width: 100%;
      padding: 10%;
      border-radius: 50%;
      animation: flower-spinner-bigger-dot-animation 2.5s 0s infinite both;
    }

    @keyframes flower-spinner-bigger-dot-animation {
      0%, 100% {
        box-shadow: #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px;
      }

      50% {
        transform: rotate(180deg);
      }

      25%, 75% {
        box-shadow: #1976d2 26px 0px 0px,
        #1976d2 -26px 0px 0px,
        #1976d2 0px 26px 0px,
        #1976d2 0px -26px 0px,
        #1976d2 19px -19px 0px,
        #1976d2 19px 19px 0px,
        #1976d2 -19px -19px 0px,
        #1976d2 -19px 19px 0px;
      }

      100% {
        transform: rotate(360deg);
        box-shadow: #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px;
      }
    }

    @keyframes flower-spinner-smaller-dot-animation {
      0%, 100% {
        box-shadow: #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px;
      }

      25%, 75% {
        box-shadow: #1976d2 14px 0px 0px,
        #1976d2 -14px 0px 0px,
        #1976d2 0px 14px 0px,
        #1976d2 0px -14px 0px,
        #1976d2 10px -10px 0px,
        #1976d2 10px 10px 0px,
        #1976d2 -10px -10px 0px,
        #1976d2 -10px 10px 0px;
      }

      100% {
        box-shadow: #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px,
        #1976d2 0px 0px 0px;
      }
    }</style>
 
  